import dynamic from 'next/dynamic'

const StoreLocaleAlert = dynamic(
  import(
    /* webpackChunkName: "preferences" */
    'components/Preferences/Alert/StoreLocaleAlert'
  ),
  {
    ssr: false,
  }
)

export default StoreLocaleAlert
